import axios from "axios";
import { mapActions } from "vuex";
import {
  errorMessage,
  infoMessage,
  sendLoginAction
} from "../components/MessageBus";

export const setTokenHeader = token => {
  axios.defaults.headers.common["token"] = token;
};

export const HTTP = axios.create({});

export default {
  methods: {
    ...mapActions({
      startLoading: "startLoading",
      endLoading: "endLoading",
      logout: "logout"
    }),
    baseRequest(method, url, data, endLoading) {
      this.startLoading();
      return new Promise(resolve => {
        HTTP.request({
          method,
          url,
          data
        })
          .then(response => {
            resolve(response.data);
            if (typeof endLoading == "undefined" || endLoading) {
              this.endLoading();
            }
          })
          .catch(error => {
            this.endLoading();
            if (error.response) {
              // The request was made and the server responded with a status code
              // that falls out of the range of 2xx
              console.log(error.response.data);

              if (
                error.response.status === 405 ||
                error.response.status === 500
              ) {
                if (error.response.data.errorCode === 3) {
                  // closeAllPopupBus();
                  // router.push("login");
                  sendLoginAction()
                  errorMessage("Seu login expirou");
                  // this.logout()
                } else if (error.response.data.errorMessage) {
                  errorMessage(error.response.data.errorMessage);
                } else if (
                  error.response.data.message &&
                  error.response.data.message.errorCode
                ) {
                  errorMessage(
                    `erro : ${error.response.data.message.errorCode} - ${
                      error.response.data.message.errorMessage
                    }`
                  );
                } else {
                  errorMessage("Ocorreu um error inesperado");
                }
              } else if (error.response.status === 504) {
                // closeAllPopupBus();
                sendLoginAction()
                errorMessage(
                  "Ocorreu um erro na comunicação em breve será restaurado"
                );
              } else if (error.response.status === 400) {
                if (error.response.data && error.response.data.errors) {
                  let errorMsg;
                  for (let i = 0; i < error.response.data.errors.length; i++) {
                    errorMsg = error.response.data.errors[i];
                    infoMessage(errorMsg.msg);
                  }
                }
              } else if (error.response.status === 401) {
                // closeAllPopupBus();
                sendLoginAction()
                console.log('sendLoginAction 401')
              } else if (error.response.data.errorMessage) {
                errorMessage(error.response.data.errorMessage);
              }
            } else if (error.request) {
              console.log(error.request);
              errorMessage(error.message);
            } else {
              // Something happened in setting up the request that triggered an Error
              console.log("Error", error.message);
              errorMessage(error.message);
            }
          });
      });
    },
    post(url, data, endLoading) {
      return this.baseRequest("post", url, data, endLoading);
    },
    get(url) {
      return this.baseRequest("get", url);
    },
    put(url, data) {
      return this.baseRequest("put", url, data);
    },
    delete(url, endLoading) {
      return this.baseRequest("delete", url, null, endLoading);
    }
  }
};



// WEBPACK FOOTER //
// /src/request/request.js